import { createStore, combineReducers, compose, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import ReportesReducer from './ReportesDucks'
import DeptaReducer from './DepartamentosDucks'
import EmpleadoReducer from './EmpleadoDucks'
import UserReducer from './Users'
import MenusReducer from './PdimMenuDucks'
import LotesReducer from './LotesDucks'
import PdimIncidenciasMovReducer from './PdimIncidenciasDucks'
const rootReducer = combineReducers({
    reportes: ReportesReducer,
    users: UserReducer,
    depta: DeptaReducer,
    empleado: EmpleadoReducer,
    menus:MenusReducer,
    lote:LotesReducer,
    pdimov:PdimIncidenciasMovReducer
})

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;


export default function generateStore() {

    const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)))
    return store;
}
